(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dg-brand-film"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('dg-brand-film')) {
    customElements.define('dg-brand-film', class extends HTMLElement {
      connectedCallback() {
        if (this.video) return;
        this.video = this.querySelector('video');
        if (!this.video) return;
        this.mobileQuery = window.matchMedia('(max-width: 749px)');
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        this.inView = false;
        this.syncPlayback = () => {
          const autoplay = this.dataset.autoplay === 'true' && !this.motionQuery.matches;
          this.video.autoplay = autoplay && this.inView;
          if (this.video.autoplay) {
            this.video.muted = true;
            this.video.play().catch(() => {});
          } else {
            this.video.pause();
          }
        };
        this.selectSource = () => {
          const mobile = this.mobileQuery.matches;
          const source = mobile ? this.dataset.mobileSrc : this.dataset.desktopSrc;
          const poster = mobile ? this.dataset.mobilePoster : this.dataset.desktopPoster;
          this.video.poster = poster;
          if (this.video.getAttribute('src') !== source) {
            this.video.src = source;
            this.video.querySelectorAll('source').forEach(node => node.remove());
            this.video.load();
          }
          this.syncPlayback();
        };
        this.selectSource();
        this.mobileQuery.addEventListener('change', this.selectSource);
        this.motionQuery.addEventListener('change', this.syncPlayback);
        this.observer = new IntersectionObserver(entries => {
          entries.forEach(entry => {
            this.inView = entry.isIntersecting && entry.intersectionRatio >= 0.2;
            this.syncPlayback();
          });
        }, { threshold: [0, 0.2] });
        this.observer.observe(this);
      }
      disconnectedCallback() {
        if (this.observer) this.observer.disconnect();
        if (this.mobileQuery && this.selectSource) this.mobileQuery.removeEventListener('change', this.selectSource);
        if (this.motionQuery && this.syncPlayback) this.motionQuery.removeEventListener('change', this.syncPlayback);
        if (this.video) this.video.pause();
        this.video = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
